import { renderSlot as _renderSlot, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "popover-trigger",
  ref: "el"
}
const _hoisted_2 = ["data-placement"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default"),
    (_ctx.visible)
      ? (_openBlock(), _createElementBlock("div", _mergeProps({ key: 0 }, _ctx.$attrs, {
          ref: "popover",
          class: ["popover", {expand: _ctx.expand}],
          style: _ctx.style,
          "data-placement": _ctx.placementRef,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args))),
          onTransitionend: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onAnimationEnd && _ctx.onAnimationEnd(...args)))
        }), [
          _renderSlot(_ctx.$slots, "content")
        ], 16, _hoisted_2))
      : _createCommentVNode("", true)
  ], 512))
}